import { isKnownExerciseVesselApiId } from './exerciseVesselRoleLookup';

/**
 * View modes where MapContainer advances `vesselPlaybackTime` while playing.
 * Must stay in sync with `VESSEL_TIMELINE_MODES` in `OceanDataContext.js` and
 * vessel `storySeries` selection in `useOceanData.js`.
 */
export const VESSEL_MAP_PLAYBACK_VIEW_MODES = new Set([
  'Vessel Tracking',
  'Relative Grid View',
  'Threat Zone',
  'Marker Clusters'
]);

export function isVesselMapPlaybackViewMode(viewMode) {
  return viewMode != null && VESSEL_MAP_PLAYBACK_VIEW_MODES.has(viewMode);
}

/**
 * Helpers for a single chronological "story" timeline (animation + vessel playback).
 */

export function getRowTimeMs(row) {
  if (!row) return NaN;
  const v = row.timestamp ?? row.time;
  if (v == null) return NaN;
  const ms = new Date(v).getTime();
  return Number.isNaN(ms) ? NaN : ms;
}

export function sortRowsByTimeAsc(rows) {
  if (!rows || rows.length === 0) return [];
  return [...rows].sort((a, b) => getRowTimeMs(a) - getRowTimeMs(b));
}

/**
 * For Exercise scenario + full rawData timeline: use only rows from known exercise vessels
 * so playback starts when exercise tracks exist (not the first timestamp of unrelated traffic).
 */
export function sortedExerciseStoryRowsFromRaw(rows) {
  if (!rows || rows.length === 0) return [];
  const sorted = sortRowsByTimeAsc(rows);
  const ex = sorted.filter((row) => isKnownExerciseVesselApiId(row.unique_identifier));
  return ex.length >= 2 ? ex : sorted;
}

/**
 * Last index in a time-sorted series whose row time is <= ms.
 */
export function frameIndexForStoryTime(ms, sortedSeries) {
  if (!sortedSeries || sortedSeries.length === 0 || Number.isNaN(ms)) return 0;
  let lo = 0;
  let hi = sortedSeries.length - 1;
  let ans = 0;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    const t = getRowTimeMs(sortedSeries[mid]);
    if (t <= ms) {
      ans = mid;
      lo = mid + 1;
    } else {
      hi = mid - 1;
    }
  }
  return ans;
}
